import type { LineGraphEndpointData, LineGraphEndpointDataItem } from 'types';

type StringNumber = string | number;
type ArrayArrayMixed = Array<Array<StringNumber>>;

export const getValues = (data: Array<LineGraphEndpointData>, dataType: string, dataKey: string): ArrayArrayMixed => (
  data.map(dataItem => (
    (dataItem[dataType] as Array<LineGraphEndpointDataItem>).map(item => item[dataKey])
  ))
);

export const calculateDataPointTotal = (totals: ArrayArrayMixed, index: number): number => {
  let count = 0;

  totals.forEach(total => {
    count += Number(total[index]) || 0;
  });

  return count;
};
